(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sv-pdp-gift"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', function (e) {
    var id = e.detail && e.detail.variant && String(e.detail.variant.id);
    if (!id) return;
    document.querySelectorAll('[data-sv-pdp-gift][data-sv-pre]').forEach(function (el) {
      el.hidden = el.dataset.svPre.split(',').indexOf(id) > -1;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-pdp-zestaw"] && !Shopify.designMode) return;
  try {
    /* P5 10.10: korzeń bloku = [data-sv-wz]; dawne data-sv-zestaw wyszukuje też assets/sv-zawartosc-zestawu.js (sekcja
     „Zawartość zestawu”), który startował na tym bloku i pisał w konsoli „Error parsing variant mappings”. */
  (function () {
    function has(list, id) {
      return (',' + (list || '') + ',').indexOf(',' + id + ',') > -1;
    }
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.id) return;
      var id = String(v.id);
      document.querySelectorAll('[data-sv-wz]').forEach(function (root) {
        if (!has(root.getAttribute('data-ids'), id)) return;
        root.querySelectorAll('[data-sv-zv]').forEach(function (el) {
          el.hidden = !has(el.getAttribute('data-sv-zv'), id);
        });
      });
    });
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-sv-zestaw-link]') : null;
      if (!a) return;
      var key = a.getAttribute('data-target') || 'zawartosc_zestawu';
      var t = (a.hash && a.hash.length > 1 && document.getElementById(a.hash.slice(1))) ||
        document.querySelector('.shopify-section[id*="__' + key + '"]');
      if (!t) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('sv:tab', { detail: { tab: 'dane', target: t } }));
      if (window.svPdpTabs) return;
      var root = document.documentElement;
      root.classList.add('sv-cv-off');
      void root.offsetHeight;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var tries = 0;
      var moved = false;
      var stop = function () {
        moved = true;
      };
      ['wheel', 'touchstart', 'keydown'].forEach(function (n) {
        window.addEventListener(n, stop, { passive: true, once: true });
      });
      var gap = function () {
        var off = parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 0;
        return t.getBoundingClientRect().top - off - 8;
      };
      /* treści nad sekcją doładowują się w trakcie przewijania (zmienia się wysokość strony), więc gdy strona stanie,
         sprawdzamy pozycję i dociągamy: co 250 ms, maks. 3 poprawki i 3 s od kliknięcia; ruch klientki (kółko, dotyk,
         klawisz) przerywa poprawki */
      var go = function () {
        window.scrollTo({ top: Math.max(0, window.pageYOffset + gap()), behavior: still ? 'auto' : 'smooth' });
      };
      var t0 = Date.now();
      var last = -1;
      var tick = function () {
        if (moved || Date.now() - t0 > 3000) return;
        var y = window.pageYOffset;
        if (y === last && tries < 3 && Math.abs(gap()) > 4) {
          tries++;
          go();
        }
        last = y;
        setTimeout(tick, 250);
      };
      go();
      setTimeout(tick, 250);
      var h = t.querySelector('h2, h3');
      if (h) {
        if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
        h.focus({ preventScroll: true });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
